import { FETCHCATS } from '../types'
import axios from 'axios';
export const fetchcats = () => {

    return (dispatch) => {
        dispatch({ type: FETCHCATS });
        //call the backend
            axios.post('https://zliten.onwan.ly/API/categories/fetchCats.php')
             .then((resp) => dispatch({ type: FETCHCATS, data: resp.data }))
            /* .then((resp) => console.log(resp.data))*/
            .catch(error => console.error(error));
    }
}
